import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import {
  AppButton,
  AppModal,
  AppTable,
  FormInput,
  FormSelect,
  SearchInput,
} from "components";
import { TableBodyContent } from "components/AppTable";
//eslint-disable-next-line
import { Router } from "utils/route";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import { userData } from "utils/userData";
import Skeleton2 from "components/Skeleton2";
import { checked, warning } from "assets/icons";
//import { add } from "assets/icons";

export default function AuditTrail({ title }) {
  const [loading, setLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const [admins, setAdmins] = useState([]);

  const [edit, setEdit] = useState(false);

  console.log(admins);

  const getConfigs = async (id) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2" ||
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "nonBankAdmin"
    ) {
      setLoading(true);
      try {
        const data = await ApiService.getConfigTrigger();
        console.log(data);
        setAdmins(data?.data);
        setLoading(false);

        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const [modal, setModal] = useState();
  const [step, setStep] = useState(0);

  //eslint-disable-next-line
  const [details, setDetails] = useState({
    emails: "",
    triggerRoute: "",
    value: "",
  });

  const emailTriggerInstitution = async () => {
    setLoading(true);
    try {
      const data = await ApiService.configTrigger({
        emails: details.emails.split(","),
        triggerRoute: details.triggerRoute,
        value: details.value,
      });
      setStep(2);
      setLoading(false);
      getConfigs();
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const editTrigger = async () => {
    setLoading(true);
    try {
      const data = await ApiService.editConfigTrigger(
        {
          emails: details.emails.split(","),
          triggerRoute: details.triggerRoute,
          value: details.value,
        },
        details?.id
      );
      setStep(2);
      setLoading(false);
      getConfigs();
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };
  console.log(details);

  useEffect(() => {
    getConfigs();
  }, []);

  return (
    <DashboardLayout>
      <AppTable
        tableHeadLength="4"
        tableHead={["EMAILS", "Route", "Approved Value", "Action"]}
        tableWidth={"fit-content"}
        titleB="Configurations"
        columnWidth="260px"
        action={getConfigs}
        transactions={admins}
        searchInput={searchInput}
        pagination={false}
        loading={loading}
        btnTitle="Add Configuration"
        btnDisabled={admins.length === 2}
        btnAction={() => {
          setModal(true);
        }}
        childrenHead={
          <div>
            <SearchInput
              width="200%"
              onChange={(e) => {
                getConfigs(`?search=${e.target.value || ""}`);
                setSearchInput(e.target.value);
              }}
            />
          </div>
        }
      >
        <TableBodyContent>
          {loading ? (
            <div style={{ width: "80vw" }}>
              <Skeleton2 height="500px" />
            </div>
          ) : (
            admins?.map((item) => {
              return (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(4, 260px)`,
                  }}
                  className="table_body_item"
                >
                  <div className="email">
                    {item?.emails?.map((item) => `${item}, `)?.slice(0, 10)}...{" "}
                    <span style={{ position: "absolute" }}>
                      {item?.emails?.map((item) => `${item}, `) || "-"}
                    </span>{" "}
                  </div>
                  <div>{item?.route || "-"}</div>
                  <div>{item?.value || "-"}</div>
                  <div>
                    <svg
                      onClick={() => {
                        setModal(true);
                        setDetails({
                          emails: item.emails.join(", "),
                          triggerRoute: item.route,
                          value: item.value,
                          id: item?.id,
                        });
                        setEdit(true);
                      }}
                      style={{
                        width: "20px",
                        marginRight: "16px",
                        cursor: "pointer",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      id="edit"
                    >
                      <path d="M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"></path>
                    </svg>
                  </div>
                </div>
              );
            })
          )}
        </TableBodyContent>
      </AppTable>

      {modal && (
        <div>
          {step === 0 && (
            <AppModal
              maxWidth={"700px"}
              closeModal={() => {
                setModal(false);
                setEdit(false);
                setStep(0);
                setDetails({
                  emails: "",
                  triggerRoute: "",
                  value: "",
                });
              }}
              headingSize="21px"
              heading={<> Configure Email Trigger</>}
            >
              <div>
                <FormInput
                  type="number"
                  label="Approved Value"
                  placeholder="Max Value"
                  onChange={(e) => {
                    setDetails({ ...details, value: e.target.value });
                  }}
                  defaultValue={details.value}
                />
              </div>
              <div>
                <FormSelect
                  label="Route"
                  value={details?.triggerRoute}
                  defaultValue={details?.triggerRoute}
                  options={[
                    { name: "DIRECT", value: "direct" },
                    { name: "NIP", value: "nip" },
                  ]}
                  optionLabel="name"
                  optionValue="value"
                  onChange={(e) => {
                    setDetails({ ...details, triggerRoute: e.target.value });
                  }}
                />
              </div>
              <div>
                <FormInput
                  type="text"
                  placeholder="Emails should be separated with commas (,)"
                  label="Add Emails"
                  onChange={(e) => {
                    setDetails({ ...details, emails: e.target.value });
                  }}
                  defaultValue={details.emails}
                />
              </div>
              <AppButton
                onClick={() => {
                  if (details.emails && details.triggerRoute && details.value) {
                    setStep(1);
                  } else {
                    toast.error("Fill Configuration Fields");
                  }
                }}
                placeholder="Proceed"
              />
              &nbsp; &nbsp;
              <AppButton
                onClick={() => {
                  setEdit(false);
                  setModal(false);
                  setStep(0);
                }}
                outline
                placeholder="Cancel"
              />
            </AppModal>
          )}
          {step === 1 && (
            <AppModal
              closeModal={() => {
                setModal(false);
                setEdit(false);

                setStep(0);
                setDetails({
                  emails: "",
                  triggerRoute: "",
                  value: "",
                });
              }}
            >
              <div>
                <img src={warning} alt="" />
                <h3>Confirm Changes</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Are you sure you want to set this configuration?
              </p>
              <div style={{ display: "flex" }}>
                <AppButton
                  onClick={() => {
                    setModal(false);
                    setStep(0);
                    setEdit(false);
                    setDetails({
                      emails: "",
                      triggerRoute: "",
                      value: "",
                    });
                  }}
                  outline
                  placeholder="Cancel"
                />
                &nbsp; &nbsp; &nbsp; &nbsp;
                <AppButton
                  onClick={() => {
                    if (edit) {
                      editTrigger();
                    } else {
                      emailTriggerInstitution();
                    }
                  }}
                  placeholder="Confirm"
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </AppModal>
          )}
          {step === 2 && (
            <AppModal
              closeModal={() => {
                setModal(false);
                setStep(0);
                setEdit(false);
                setDetails({
                  emails: "",
                  triggerRoute: "",
                  value: "",
                });
              }}
            >
              <div>
                <img src={checked} alt="" />
                <h3>Changes saved</h3>
              </div>
              <p style={{ margin: "30px 0" }}>Successfully configured.</p>
            </AppModal>
          )}
        </div>
      )}
    </DashboardLayout>
  );
}
